import { atributos } from '@/services/propriedade'

export default {
	async setObjectProps (context, payload) {
		context.commit('LOAD_OBJECT_PROPS', { data: payload })
	},
	async loadNewObjectProps (context, payload) {
		await atributos.findByTipo(payload)
			.then(res => {
				if (res.data) {
					res.data.forEach(item => {
						if (context.state.list.findIndex(l => l.id === item.id) < 0) {
							item.data = { propriedadeId: item.id, valor: item.multiplo ? [] : '' }
							context.commit('ADD_NEW_OBJECT_PROPS', item)
						}
					})
				}
			})
			.catch(err => {
				console.log(err)
			})
	},
	async loadObjectProps (context, payload) {
		const props = []
		await atributos.findByTipo(payload)
			.then(res => {
				if (res.data) {
					res.data.forEach(item => {
						item.persisted = true
						props.push(item)
					})
					context.commit('LOAD_OBJECT_PROPS', { data: props })
				}
			})
			.catch(err => {
				console.log(err)
			})
	},
	async unloadObjectProps (context, payload) {
		context.commit('UNLOAD_OBJECT_PROPS', { data: [] })
	},
	async unloadUnpersistedProps (context, payload) {
		const index = context.state.list.findIndex(l => !l.persisted)
		if (index > 0) context.commit('UNLOAD_UNPERSISTED_PROPS', { index })
	},
	editProp (context, payload) {
		const index = context.state.list.findIndex(l => l.id === payload.id)
		context.commit('EDIT_OBJECT_PROP', { index, data: payload })
	},
	addValueProp (context, payload) {
		const { id, value, multiplo } = payload
		const index = context.state.list.findIndex(l => l.id === id)
		multiplo
			? context.commit('ADD_VALUE_IN_MULT_PROPS', { index, data: value })
			: context.commit('ADD_VALUE_IN_SIMP_PROPS', { index, data: value })
	},
	removeValueProp (context, payload) {
		const { valueIndex, id, multiplo } = payload
		const propIndex = context.state.list.findIndex(l => l.id === id)
		multiplo
			? context.commit('REMOVE_VALUE_IN_MULT_PROPS', { propIndex, valueIndex })
			: context.commit('REMOVE_VALUE_IN_SIMP_PROPS', { propIndex })
	},
	async formateProperties (context, payload) {
		const props = []
		context.state.list.forEach(item => {
			if (Array.isArray(item.data.valor)) {
				let string = ''
				item.data.valor.forEach((v, index) => {
					const separador = index === item.data.valor.length - 1 ? '' : '|'
					string = string.concat(`${v}${separador}`)
				})

				if (string) {
					props.push({ propriedadeId: item.id, valor: string })
				}
			} else {
				props.push({ propriedadeId: item.id, valor: item.data.valor })
			}
		})
		return props
	},
	async sanatizedProps (context, payload) {
		const separador = '|'
		const props = []
		const { ids, valores, nomes, multiplos, tiposEntrada, valoresDefault, obrigatorios, tipo } = payload
		ids.forEach((item, index) => {
			const prop = {
				id: item,
				nome: nomes[index],
				flagAtivo: true,
				tipoEntrada: tiposEntrada[index],
				multiplo: multiplos[index],
				valorDefault: valoresDefault[index],
				obrigatorio: obrigatorios[index],
				tipoId: tipo,
				data: {
					propriedadeId: item,
					valor: multiplos[index] && valores.length && valores[index] ? valores[index].split(separador) : valores[index]
				},
				persisted: true
			}
			props.push(prop)
		})
		return props
	}
}
